import styled from 'styled-components';

const ColorIndicator = styled.div`
  border-radius: 16px;
  height: 16px;
  width: 16px;
  line-height: 0px;
  background-color: ${(props) => props.color};
`;

export default ColorIndicator;
